import { mainSiteUrl } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-accent-600 text-xs font-medium tracking-wider uppercase mb-6">
          Cos&apos;è Itaobuy Sheet
        </span>

        <div className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight mb-8 space-y-2">
          <p>
            Il tuo <span className="italic text-primary-500">spreadsheet</span> intelligente
          </p>
          <p>
            per organizzare <span className="italic text-accent-600">dati e prodotti</span>
          </p>
          <p>
            con stile <span className="italic text-primary-500">italiano</span>
          </p>
        </div>

        <div className="prose prose-lg mx-auto text-foreground-600 max-w-3xl">
          <p className="text-base md:text-lg leading-relaxed mb-6">
            <strong>Itaobuy Spreadsheet</strong> è una soluzione digitale innovativa che permette
            agli utenti di organizzare, analizzare e gestire dati attraverso strumenti spreadsheet
            moderni e intuitivi. Pensato per il mercato italiano, combina la potenza dei fogli di
            calcolo avanzati con un&apos;interfaccia semplice e accessibile a tutti.
          </p>
          <p className="text-base md:text-lg leading-relaxed mb-6">
            Che tu sia un professionista, un imprenditore o semplicemente una persona che vuole
            tenere traccia delle proprie attività, <strong>Itaobuy Sheet</strong> ti offre tutti
            gli strumenti necessari per lavorare in modo efficiente. Dalla gestione dell&apos;inventario
            all&apos;analisi dei dati di vendita, dall&apos;organizzazione di progetti personali alla
            creazione di report professionali.
          </p>
          <p className="text-base md:text-lg leading-relaxed">
            La nostra piattaforma si distingue per l&apos;affidabilità, la sicurezza dei dati e
            un&apos;esperienza utente progettata per adattarsi alle esigenze specifiche degli
            utenti italiani. Con aggiornamenti costanti e un team dedicato al supporto,
            <strong> Itaobuy Spreadsheet</strong> è la scelta ideale per chi cerca uno strumento
            completo e affidabile.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {[
            {
              icon: "ri-shield-check-line",
              title: "Facile da Usare",
              desc: "Interfaccia intuitiva progettata per tutti i livelli di esperienza",
            },
            {
              icon: "ri-database-2-line",
              title: "Gestione Intelligente",
              desc: "Organizzazione avanzata dei dati con funzioni automatiche",
            },
            {
              icon: "ri-tools-line",
              title: "Strumenti Avanzati",
              desc: "Funzionalità professionali per analisi e reportistica",
            },
            {
              icon: "ri-rocket-line",
              title: "Massima Produttività",
              desc: "Risparmia tempo con automazioni e template predefiniti",
            },
          ].map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center group hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center text-primary-500 text-xl">
                <i className={item.icon}></i>
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Visita Itaobuy Spreadsheet
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}